import { skipToken } from '@reduxjs/toolkit/query';
import { CommanderAPI } from '../CommanderAPI';
import { useAppSelector } from '../../../../redux/store.model';
import { getMyWorkspaceSelector } from '../../../../redux/workspace/selectors/Workspace.selectors';
import { ITypeRequest } from '../../../../theme/ui/Dashboard/Dashboard.model';
import { DeviceStatusMapAPIResponse } from '../deviceStatus.model';

function selectFromResult<T extends { data?: DeviceStatusMapAPIResponse[] }>({
  data,
  ...rest
}: T) {
  return {
    ...rest,
    data: data?.filter((device) => device.mqttConnected !== true),
  };
}
interface IUseCommanderOfflineProps {
  groupId?: string;
  workspaceId?: string;
  typeRequest: ITypeRequest;
}
function useCommanderOffline(props: IUseCommanderOfflineProps) {
  const { typeRequest, groupId, workspaceId } = props;

  const userDevicesConnectionStatusResponse =
    CommanderAPI.useGetDevicesConnectionStatusByUserQuery(undefined, {
      skip: typeRequest !== 'user',
      selectFromResult,
    });

  const groupDevicesConnectionStatusResponse =
    CommanderAPI.useGetDevicesConnectionStatusByGroupQuery(
      groupId ?? skipToken,
      {
        skip: typeRequest !== 'group',
        selectFromResult,
      }
    );

  const workspaceDevicesConnectionStatusResponse =
    CommanderAPI.useGetDevicesConnectionStatusByWorkspaceQuery(
      workspaceId ?? skipToken,
      {
        skip: typeRequest !== 'workspace',
        selectFromResult,
      }
    );
  const myWorkspace = useAppSelector(getMyWorkspaceSelector);

  const workspacesDevicesConnectionStatusResponse =
    CommanderAPI.useGetDevicesConnectionStatusByWorkspaceQuery(
      myWorkspace?.id ?? skipToken,
      {
        skip: typeRequest !== 'workspaces',
        selectFromResult,
      }
    );

  switch (typeRequest) {
    case 'user':
      return userDevicesConnectionStatusResponse;
    case 'group':
      return groupDevicesConnectionStatusResponse;
    case 'workspace':
      return workspaceDevicesConnectionStatusResponse;
    case 'workspaces':
      return workspacesDevicesConnectionStatusResponse;
    default:
      return userDevicesConnectionStatusResponse;
  }
}

export default useCommanderOffline;
